import {
  LoginVerifyCodeData,
  TwoFactorCodeVerifiedResponse,
} from '../../../../types/requests';
import { ConstructPost } from '../../../types/ConstructPost';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { TWO_FACTOR_BASE_PATH } from '../constants/twoFactorBasePath';

export const postVerifyCode = (
  constructPost: ConstructPost,
  data: LoginVerifyCodeData,
): Promise<NonPaginatedResponse<TwoFactorCodeVerifiedResponse> | undefined> =>
  constructPost<NonPaginatedResponse<TwoFactorCodeVerifiedResponse>>(
    `${TWO_FACTOR_BASE_PATH}/verify`,
    { data },
    { preventDefaultErrorToast: true },
  );
